import axiosIns from "./axios"

export const PROFILE = () => {
    return axiosIns.get('/users/identify')
}